import { useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { ReactComponent as LogoSVG } from '../images/logo__B-C-arch.svg'
import { links } from '../data'
import { TbMenu, TbMenu2 } from 'react-icons/tb'
import './navbar.css'


const Navbar = () => {
  const [isNavShowing, setIsNavShowing] = useState(false);

  return (
    <nav role="banner" className="nav-bar">
        <div className="container nav__container">
            <Link to="/" className="logo" onClick={() => setIsNavShowing(false)}>
              <LogoSVG />
            </Link>
            <ul className={`nav__links ${isNavShowing ? "links--show" : "links--hide"}`}>
              {
                links.map(({name, path}, index) => {
                  return (
                    <li key= {index}>
                      <NavLink to={path} className={({isActive}) => isActive ? "active-nav" : ""} onClick={() => setIsNavShowing(prev => !prev)}>{name}</NavLink>
                    </li>
                  )
                })
              }
            </ul>
            <button className="nav__toggle-btn" onClick={() => setIsNavShowing(prev => !prev)}>
                {
                  isNavShowing ? <TbMenu2 /> : <TbMenu />
                }
            </button>
        </div>
    </nav>
  )
}

export default Navbar